import React from "react";
import "./About.css";

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-image">
        <img src="about.jpg" alt="Cab service" />
      </div>
      <div className="about-content">
        <h2 className="head">Our Mobility Excellence</h2>
        <p>
          Welcome to <strong>UzhavanTaxi</strong> — your reliable and comfortable travel partner.
          We provide fast, safe, and affordable cab services across the city and beyond.
          Whether it’s a local ride, airport transfer, or outstation trip, our professional
          drivers ensure you reach your destination on time and with comfort.
        </p>
        <p>
          Our mission is to make every journey hassle-free, offering easy booking,
          transparent pricing, and 24/7 customer support. Choose TaxiBook and
          enjoy smooth rides every time!
        </p>
        <button onClick={() => {document.getElementById('contact').scrollIntoView({behavior:"smooth"});}}>Schedule Ride</button>
      </div>
    </section>
  );
};
export default About;
